// extracted by mini-css-extract-plugin
module.exports = {"btn":"Footer_btn__DFkXM","bookmark":"Footer_bookmark__QXZUL","tel":"Footer_tel__BtWsw","telBorder":"Footer_telBorder__tG4Dg","reservation":"Footer_reservation__b3D50"};